import { High, Main, Standard, VEITS } from '@/models/security-method-enums-generated'

export const securityNeed = [Main, Standard, High, VEITS] as const
export const categories = ['confidentiality', 'integrity', 'availability'] as const
